import {
  forEach, reduce, values, chain, join, orderBy, uniqBy, isArray, keyBy,
} from 'lodash';
import {
  FETCH_ADMIN_INFO_SUCCEED,
  FETCH_ADMIN_LOGIN_HISTORY_SUCCEED,
  FETCH_ALL_ADMIN_SUCCEED,
  FETCH_AUTH_INFO_SUCCEED,
  FETCH_LIMIT_WITHDRAWAL_OF_ADMIN_SUCCEED, FETCH_OWN_BALANCE_SUCCESS,
} from '../actions/admin/action_types';
import { FETCH_USER_VOLUME_24H_SUCCEED } from '../actions/transactions/action_types';

export default (
  state = {
    listAdmins: [],
    loginHistories: [],
    authInfo: {},
    permissions: [],
    mapPermissions: {},
    adminInfo: {},
    limitWithdrawals: [],
    limit24h: 0,
    balances: [],
    mapBalances: {},
  },
  action,
) => {
  switch (action.type) {
    // fetch order history
    case FETCH_OWN_BALANCE_SUCCESS:
      const mapBalances = reduce(action.data, (result, userBalance) => {
        result[userBalance.coin] = userBalance;
        result[userBalance.coin].key = userBalance.coin;
        return result;
      }, {});

      return {
        ...state,
        balances: values(mapBalances),
        mapBalances,
      };
    case FETCH_ALL_ADMIN_SUCCEED:
      return {
        ...state,
        listAdmins: action.data,
      };
    case FETCH_ADMIN_LOGIN_HISTORY_SUCCEED:
      return {
        ...state,
        loginHistories: action.data,
      };
    case FETCH_AUTH_INFO_SUCCEED:
      const allPermissions = values(action.data.permissions);
      window.mapPerms = keyBy(allPermissions, 'path');

      return {
        ...state,
        authInfo: action.data,
        permissions: allPermissions,
        mapPermissions: window.mapPerms,
      };

    case FETCH_ADMIN_INFO_SUCCEED:
      return {
        ...state,
        adminInfo: action.data,
      };

    case FETCH_LIMIT_WITHDRAWAL_OF_ADMIN_SUCCEED:
      const limitWithdrawals = action.coins;

      forEach(action.data, (limit) => {
        limitWithdrawals[limit.currency] = {
          ...limitWithdrawals[limit.currency],
          ...limit,
        };
      });

      return {
        ...state,
        limitWithdrawals: values(limitWithdrawals),
      };
    case FETCH_USER_VOLUME_24H_SUCCEED:
      return {
        ...state,
        limit24h: action.data,
      };
    default:
      return {
        ...state,
      };
  }
};
